import type { AxiosError } from 'axios';

export function checkStatusCode(error: AxiosError<any>, targetStatusCode: number, targetStatus: string): boolean {
  const status = error.response?.status;
  const statusText = error.response?.statusText;
  const code = error.response?.data?.code;

  return status === targetStatusCode && [statusText, code].includes(targetStatus);
}
